import tokensTabTemplate from './tokensTabTemplate';

export default tokensTabTemplate('tokens', ['tokens'], ({ users }) => users.token_read);
